import React, { useEffect, useState } from "react";
import axios from "axios";

const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API = `${ENV_API_BASE_URL}/api/why-choose-heading`;

function HomeWhyChooseHeading() {
    const [data, setData] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [formData, setFormData] = useState({
        mainHeading: "",
        subHeading: ""
    });
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await axios.get(API);
            setData(Array.isArray(res.data.data) ? res.data.data : []);
        } catch (error) {
            console.error("Fetch error:", error);
            setData([]);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            // Explicitly stringify and set headers to fix data not saving
            const config = {
                headers: { "Content-Type": "application/json" }
            };

            if (editId) {
                await axios.put(`${API}/${editId}`, JSON.stringify(formData), config);
            } else {
                await axios.post(API, JSON.stringify(formData), config);
            }

            setFormData({ mainHeading: "", subHeading: "" });
            setEditId(null);
            setShowForm(false);
            fetchData();

        } catch (error) {
            console.error("Submit error:", error.response?.data || error.message);
            setError(error.response?.data?.error || "Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (item) => {
        setFormData({
            mainHeading: item.mainHeading,
            subHeading: item.subHeading
        });
        setEditId(item._id);
        setShowForm(true);
        setError("");
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this?")) return;
        try {
            await axios.delete(`${API}/${id}`);
            fetchData();
        } catch (error) {
            console.error("Delete error:", error.response?.data || error.message);
        }
    };

    const handleCancel = () => {
        setShowForm(false);
        setEditId(null);
        setFormData({ mainHeading: "", subHeading: "" });
        setError("");
    };

    return (
        <div className="container pt-5 mt-5">
            {!showForm && (
                <>
                    <button
                        className="btn btn-primary mb-3"
                        onClick={() => { setShowForm(true); setError(""); }}
                    >
                        + Create
                    </button>

                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Main Heading</th>
                                <th>Sub Heading</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center text-muted">
                                        No records found
                                    </td>
                                </tr>
                            ) : (
                                data.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{index + 1}</td>
                                        <td>{item.mainHeading}</td>
                                        <td>{item.subHeading}</td>
                                        <td>
                                            <button
                                                className="btn btn-warning btn-sm me-2"
                                                onClick={() => handleEdit(item)}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleDelete(item._id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </>
            )}

            {showForm && (
                <form onSubmit={handleSubmit} className="card p-4">
                    <h5 className="mb-3">{editId ? "Edit Heading" : "Create Heading"}</h5>

                    {error && (
                        <div className="alert alert-danger">{error}</div>
                    )}

                    <div className="mb-3">
                        <label className="form-label">Main Heading</label>
                        <input
                            type="text"
                            name="mainHeading"
                            className="form-control"
                            value={formData.mainHeading}
                            onChange={handleChange}
                            placeholder="Enter main heading"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Sub Heading</label>
                        <input
                            type="text"
                            name="subHeading"
                            className="form-control"
                            value={formData.subHeading}
                            onChange={handleChange}
                            placeholder="Enter sub heading"
                            required
                        />
                    </div>

                    <div className="mt-3">
                        <button
                            type="submit"
                            className="btn btn-success"
                            disabled={loading}
                        >
                            {loading ? "Saving..." : editId ? "Update" : "Save"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary ms-2"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
}

export default HomeWhyChooseHeading;
